import { ApiTransaction } from '../../openapi';
import { TransactionListItem as BrightyTransactionListItem, Typography } from '@razz-team/ui-web';
import { TransactionIcon } from './TransactionIcon';
import { useNavigate } from '@tanstack/react-router';
import { useTransactionDetails } from '../../utils/useTransactionDetails';

export function TransactionListItem({ transaction }: { transaction: ApiTransaction }) {
  const transactionData = useTransactionDetails({ transaction });
  const navigate = useNavigate();

  return (
    <BrightyTransactionListItem
      onClick={() =>
        navigate({
          to: `/account/transactions/$transactionId`,
          params: { transactionId: transaction.id },
          search: { createdAt: transaction.date.created },
        })
      }
      title={transactionData.title}
      subtitle={transactionData.time}
      icon={<TransactionIcon transaction={transaction} />}
      value={
        <Typography
          color={transactionData.valueColor}
          variant="body1"
          sx={{ minWidth: '30%', textAlign: 'end' }}
        >
          {transactionData.value}
        </Typography>
      }
      sx={{ userSelect: 'none' }}
      subvalue={transactionData.subvalue}
    />
  );
}
